export default {
  totalPriceWithTaxs: {
    id: 'bo_sellers-orders-components-orders_table-total_price_with_taxs',
    defaultMessage: 'Total price incl. tax',
  },
  seeFinancialDetails: {
    id: 'bo_sellers-orders-components-orders_table-actions-see_financial_details',
    defaultMessage: 'See cost breakdown',
  },
  timeBeforeExpirationInMinutes: {
    id: 'bo_sellers-orders-components-orders_table-actions-expiration_time_in_minutes',
    defaultMessage: '{time} min remaining',
  },
  timeBeforeExpirationInHours: {
    id: 'bo_sellers-orders-components-orders_table-actions-expiration_time_in_hours',
    defaultMessage: '{time} hrs remaining',
  },
  refundedPrice: {
    id: 'bo_sellers-orders-components-orders_table-actions-refunded_price',
    defaultMessage: 'Refunded {price}',
  },
  fullRefund: {
    id: 'bo_sellers-orders-components-orders_table-actions-full_refund',
    defaultMessage: 'Total refund',
  },
} as const
